import request from '@/request'

// 获取二级栏目
export const getCategorylist = data => {
  return request({
    url: '/mobile_portalContent/categorylist.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

// 获取新闻列表
export const getNewslist = data => {
  return request({
    url: '/mobile_portalContent/list.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取多个新闻列表
export const getNewslistAll = data => {
  return request({
    url: 'exterior_portalContent/listForContent.action',
    data: data,
    method: 'post',
    isMd5: false
  })
}
/* 获取新闻中心列表详情 */
export const getListsdetail = data => {
  return request({
    url: '/mobile_portalContent/view.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 获取列表详情浏览量 */
export const getListsread = data => {
  return request({
    url: '/exterior_portalContent/updateReadcnt.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 获取调查问卷列表 */
export const getSurveyList = data => {
  return request({
    url: '/inf_Quesinfo_Vipwd/getActivity.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取活动标题 */
export const getTitle = data => {
  return request({
    url: '/inf_Quesinfo_Vipwd/getTitle.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取调查问卷题目 */
export const getSurveyQuestion = data => {
  return request({
    url: '/inf_Quesinfo_Vipwd/getPaper.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 提交问卷题目 */
export const postSurvey = data => {
  return request({
    url: '/inf_Quesinfo_Vipwd/submit.action',
    method: 'post',
    data: data,
    isMd5: true,
    msgTitle: '提示'
  })
}
/* 获取团购活动列表 */
export const getActivity = data => {
  return request({
    url: '/mobile_Group_Vipwd/list.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取团购活动详情 */
export const getActivityDetail = data => {
  return request({
    url: '/mobile_Group_Vipwd/view.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取个人团购列表 */
export const getPersonTuangou = data => {
  return request({
    url: '/mobile_Group_Vipwd/userList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 报名参团 */
export const getJoin = data => {
  return request({
    url: '/mobile_Group_Vipwd/join.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取会员活动列表 */
export const getActivitylist = data => {
  return request({
    url: '/mobile_Member_Vipwd/list.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 添加信件 */
export const AddLetter = data => {
  return request({
    url: '/inf_Letter_Vipwd/addLetter.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到来访人信件列表 */
export const getAccountList = data => {
  return request({
    url: '/inf_Letter_Vipwd/getAccountList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到来访人信件详情 */
export const getAccountDetail = data => {
  return request({
    url: '/inf_Letter_Vipwd/getAccountDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到处理信件列表 */
export const getDealList = data => {
  return request({
    url: '/inf_Letter_Vipwd/getDealList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到指派信件列表 */
export const getAppointList = data => {
  return request({
    url: '/inf_Letter_Vipwd/getAppointList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到已处理指派信件列表 */
export const getDealAppointList = data => {
  return request({
    url: '/inf_Letter_Vipwd/getDealAppointList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到处理信件详情 */
export const getDealDetail = data => {
  return request({
    url: '/inf_Letter_Vipwd/getDealDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到流水 */
export const getFlow = data => {
  return request({
    url: '/inf_Letter_Vipwd/getFlow.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 本部室工作人员回复 */
export const dealLetter = data => {
  return request({
    url: '/inf_Letter_Vipwd/dealLetter.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 非本部室工作人员回复 */
export const dealAppoint = data => {
  return request({
    url: '/inf_Letter_Vipwd/dealAppoint.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到用户列表 */
export const getUserList = data => {
  return request({
    url: '/inf_FtuWxcpAccount_Vipwd/getUserList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 指派信件 */
export const appoint = data => {
  return request({
    url: '/inf_Letter_Vipwd/appoint.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 回退指派信件 */
export const backAppoint = data => {
  return request({
    url: '/inf_Letter_Vipwd/backAppoint.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 审核通过 */
export const auditPass = data => {
  return request({
    url: '/inf_Letter_Vipwd/auditPass.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 审核不通过 */
export const auditUnpass = data => {
  return request({
    url: '/inf_Letter_Vipwd/auditUnpass.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取商品分类 */
export const getClassify = data => {
  return request({
    url: '/integral_prod/getProdTypeList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取商品列表 */
export const getProductList = data => {
  return request({
    url: '/integral_prod/list_sx.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取商品列表 */
export const getWechatPayProductList = data => {
  return request({
    url: '/integral_prod/list_test.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取商品详情 */
export const getProductDetail = data => {
  return request({
    url: '/integral_prod/view.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取订单提交 */
export const sumbitOrder = data => {
  return request({
    url: '/integral_order/addorder.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取订单列表 */
export const getOrderlist = data => {
  return request({
    url: '/integral_order/orderlist_sx.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取订单详情 */
export const getOrderDetail = data => {
  return request({
    url: '/integral_order/orderview.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 确认收货 */
export const confirmGoods = data => {
  return request({
    url: '/integral_order/confirm.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取文章详细 */
export const getArticleView = data => {
  return request({
    url: '/mobile_CommentAndLiked/getArticleView.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 获取评论列表 */
export const selectComment = data => {
  return request({
    url: '/mobile_CommentAndLiked/selectComment.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 添加评论 */
export const addComment = data => {
  return request({
    url: '/mobile_CommentAndLiked/addComment.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 点赞 */
export const addLiked = data => {
  return request({
    url: '/mobile_CommentAndLiked/addLiked.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 取消点赞 */
export const cancelLiked = data => {
  return request({
    url: '/mobile_CommentAndLiked/cancelLiked.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 问卷次数限制 */
export const check = data => {
  return request({
    url: '/inf_Quesinfo_Vipwd/check.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取新闻栏目接口 */
export const getCategory = data => {
  return request({
    url: '/mobile_portalCategory/list.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 我的待办接口 */
export const myDeal = data => {
  return request({
    url: '/mobile_MyDealt/myDeal.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 1.66.15 得到领导列表
export const getLeadList = data => {
  return request({
    url: '/inf_FtuWxcpAccount_Vipwd/getLeadList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 1.66.13 请示领导
export const askleader = data => {
  return request({
    url: '/inf_Letter_Vipwd/askleader.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 1.66.16 得到已处理领导信件列表
export const getDealLeadList = data => {
  return request({
    url: '/inf_Letter_Vipwd/getDealLeadList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 1.66.15 得到待处理领导列表
export const getDealLeadList2 = data => {
  return request({
    url: '/inf_Letter_Vipwd/getLeadList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 父亲节活动
export const getView = (data) => {
  return request({
    url: '/mobile_PartyInfo/view.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const solicitatioAdd = (data) => {
  return request({
    url: '/party_solicitatio/addYZ.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const solicitatioQuery = (data) => {
  return request({
    url: '/party_solicitatio/queryYZ.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const getPartyVoteLisRank = (data) => {
  return request({
    url: '/mobile_PartyVote/listVoteRank.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const getPartyVoteList = (data) => {
  return request({
    url: '/mobile_PartyVote/listnew.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const getPartyVoteDetail = (data) => {
  return request({
    url: '/mobile_PartyVote/viewinfo.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const addVotePartyVotelog = (data) => {
  return request({
    url: '/mobile_PartyVotelog/add.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const addCount = (data) => {
  return request({
    url: '/mobile_PartyVotelog/addCount.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const getMd5Openid = (data) => {
  return request({
    url: '/inf_FtuWxcpUser_Vipwd/getMd5Openid.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const readbooklistsz = (data) => {
  return request({
    url: '/exterior_intFtuMediaEbooks/readbooklistsz.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 新增电子期刊
// 获取所有书籍
export const getAllBook = (data) => {
  return request({
    url: '/exterior_intFtuQkBaseinfo/getAllBook.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取目录
export const getAllCatalogue = (data) => {
  return request({
    url: '/exterior_intFtuQkNumberinfo/getAllCatalogue.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取所有文章
export const getArticle = (data) => {
  return request({
    url: '/exterior_intFtuQkArticleinfo/getArticle.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 电子期刊目录新增浏览量
export const addPageView1 = (data) => {
  return request({
    url: '/exterior_intFtuQkBaseinfo/addPageView.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 电子期刊内容页新增浏览量
export const addPageView2 = (data) => {
  return request({
    url: '/exterior_intFtuQkArticleinfo/addPageView.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 新闻详情点赞
export const postZan = (data) => {
  return request({
    url: 'exterior_portalContent/addLike.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 查询点赞
export const getListszan = (data) => {
  return request({
    url: 'exterior_portalContent/getLikes.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 投骰子活动获取格子明细
export const getCellDetail = (data) => {
  return request({
    url: '/mobile_DiceParty/getCellDetail.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 投骰子活动获取当前格子
export const getStep = (data) => {
  return request({
    url: '/mobile_DiceParty/getStep.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 投骰子活动新增当前位子
export const addStep = (data) => {
  return request({
    url: '/mobile_DiceParty/addStep.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 投骰子活动获取问号随机数
export const getRandomNum = (data) => {
  return request({
    url: '/mobile_DiceParty/getRandomNum.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 投骰子活动更新抽奖
export const updateZj = (data) => {
  return request({
    url: '/mobile_DiceParty/updateZj.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 投骰子活动邀请
export const invitedice = (data) => {
  return request({
    url: '/exterior_GriddleInviteinfo/invite.action',
    method: 'post',
    data,
    isMd5: false
  })
}
